import { render, staticRenderFns } from "./Finalizadora.vue?vue&type=template&id=4bd8e30b"
import script from "./Finalizadora.vue?vue&type=script&lang=js"
export * from "./Finalizadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports